(function(ebusy, $) {
	ebusy.initPicker = function() {
		
		var optionsNotRequired = {
			 size: "auto",
			 actionsBox: false,
			 selectedTextFormat: "count > 2",
			 noneSelectedText: "",
			 style: "btn-default",
			 selectAllText: ebusy.selectAllText,
			 deselectAllText: ebusy.selectNoneText,
			 noneResultsText: ebusy.noneResultsText,
			 countSelectedText: ebusy.countSelectedText,
			 windowPadding: [150, 0, 150, 0],
			 showTick: false
		};
		
		var optionsRequired = $.extend({}, optionsNotRequired);
		optionsRequired.noneSelectedText = ebusy.noneSelectedText;
		
		$(".selectpicker:not(.required)").each(function() {

			var options = $.extend({}, optionsNotRequired);

			var allSelectedText = $(this).data("all-selected-text");
			if(allSelectedText) {
				options.countSelectedText = function (numSelected, numTotal) {
					return numSelected === numTotal ?
						allSelectedText :
						ebusy.countSelectedText;
				}
				var numberOfOptions = $(this).children("option").length;
				var countCutoff = Math.min(numberOfOptions - 1, 2);
				options.selectedTextFormat = 'count > ' + countCutoff;
			}

			if($(this).data("actions-box")) {
				options.actionsBox = $(this).data("actions-box");
			}
			
			if($(this).data("none-selected-text")) {
				options.noneSelectedText = $(this).data("none-selected-text");
			}
			
			$(this).selectpicker(options);
		});
		
		$(".selectpicker.required").each(function() {

			var options = $.extend({}, optionsRequired);

			var allSelectedText = $(this).data("all-selected-text");
			if(allSelectedText) {
				options.countSelectedText = function (numSelected, numTotal) {
					return numSelected === numTotal ?
						allSelectedText :
						ebusy.countSelectedText;
				}
				var numberOfOptions = $(this).children("option").length;
				var countCutoff = Math.min(numberOfOptions - 1, 2);
				options.selectedTextFormat = 'count > ' + countCutoff;
			}

			if($(this).data("actions-box")) {
				options.actionsBox = $(this).data("actions-box");
			}
			
			if($(this).data("none-selected-text")) {
				options.noneSelectedText = $(this).data("none-selected-text");
			}
			
			$(this).selectpicker(options);
			
		});
	}
})(window.ebusy = window.ebusy || {}, window.jQuery);


$(function() {
	
	/**
	 * Register handler on form init.
	 */
	$(document).on("form.init", function () {
		ebusy.initPicker();
	});
	
	ebusy.initPicker();
});
